import React from "react"
import {
  Navigation,
  NavigationList,
  NavigationListLink,
  LanguageSwitch
} from "~/components/"
import {useTranslation} from "react-i18next"

const signInIcon = require("~/icons/sign_in_16_white.svg")

const GuestNavigation = () => {
  const {t} = useTranslation()
  return (
    <Navigation>
      <NavigationList>
        <NavigationListLink to="/" icon={signInIcon}>
          {t("login.title")}
        </NavigationListLink>
      </NavigationList>
      <div
        style={{
          paddingTop: 20,
          paddingRight: 20,
          paddingBottom: 80,
          paddingLeft: 20,
          boxSizing: "border-box",
          width: "100%",
          background: "rgb(51, 51, 51)"
        }}
        class="sh-intro-section-text"
      >
        <div style={{color: "white", fontSize: 15, marginBottom: 10}}>
          <LanguageSwitch />
        </div>
      </div>
    </Navigation>
  )
}

export default GuestNavigation



// WEBPACK FOOTER //
// ./src/components/navigations/GuestNavigation.js